<template>
  <section class="i-settings">
<!--    <v-tabs dark hide-slider>-->
<!--      <v-tab-->
<!--        v-for="tab in tabs"-->
<!--        :key="`tab-${tab.page}`"-->
<!--        ripple-->
<!--        :to="{ name: 'static-pages-content-pages', params: { page: tab.page } }"-->
<!--      >-->
<!--        {{ tab.name }}-->
<!--      </v-tab>-->
<!--    </v-tabs>-->
    <v-card class="i-settings__content">
      <router-view />
    </v-card>
  </section>
</template>

<script>
import pageContent from './pageContent'
import { mapGetters, mapActions } from 'vuex'
import mixins from '@/utils/mixins'

export default {
  name: 'StaticPagesContent',
  components: {
    pageContent
  },
  data () {
    return {
      scrollToTop: true,
      tabs: [
        {
          name: 'Home',
          page: 'home'
        },
        {
          name: 'About',
          page: 'about'
        },
        {
          name: 'Agenda',
          page: 'agenda'
        },
        {
          name: 'Venue',
          page: 'venue'
        },
        {
          name: 'Speakers',
          page: 'speakers'
        },
        {
          name: 'Sponsors & Exhibitors',
          page: 'Sponsors & Exhibitors'
        },
        // {
        //   name: 'FloorPlan',
        //   page: 'floor-plan'
        // },
        {
          name: 'Contact',
          page: 'contact'
        },
        {
          name: 'Footer',
          page: 'footer'
        },
        {
          name: 'Attendee',
          page: 'attendee'
        },
        {
          name: 'Success Message',
          page: 'success message'
        },
        {
          name: 'Error Message',
          page: 'error message'
        },
        {
          name: 'Registration errors',
          page: 'registration-errors'
        },
        {
          name: 'Thank you page',
          page: 'thank-you'
        },
        {
          name: 'Registration text',
          page: 'registration-text'
        },
        {
          name: 'awards',
          page: 'awards'
        },
        {
          name: 'networking-blitz',
          page: 'networking-blitz'
        },
        {
          name: 'trading-floor',
          page: 'trading-floor'
        },
        {
          name: 'video-gallery',
          page: 'video-gallery'
        },
        {
          name: 'press-pack',
          page: 'press-pack'
        },
        {
          name: 'terms-and-conditions',
          page: 'terms-and-conditions'
        },
        {
          name: 'voucher',
          page: 'voucher'
        },
        {
          name: 'social',
          page: 'social'
        }
      ]
    }
  },
  computed: {
    ...mapGetters(['staticContent'])
  },
  methods: {
    ...mapActions(['fetchStaticContent'])
  },
  mounted () {
    this.fetchStaticContent()
  }
}
</script>

<style lang="scss" scoped>
  .i-settings {
    &__content {
      padding: 15px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/StaticPages/Content.vue